























import { defineComponent, onMounted, onUnmounted, ref, getCurrentInstance } from '@vue/composition-api';
import { i18n_t } from '@/locales/i18n';
import ipc from '@/renderer/scripts/utils/ipc';
import hotkeyDataHelper from '@/renderer/scripts/utils/hotkeyDataHelper';
import { IS_OPEN_IN_MAC } from '@/common/constant';
import store from '@/renderer/store';

export default defineComponent({
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const hotkeyHelpDrawerShow = ref(false);
    const onShowHotKeyDrawer = () => {
      hotkeyHelpDrawerShow.value = !hotkeyHelpDrawerShow.value;
    };
    const onClose = () => {
      ipc.emit(ipc.RENDERER_EVENTS_MAP.FOCUS_LIST);
    };
    const onkeydwon = (event: KeyboardEvent) => {
      if (event.code === 'KeyH' && event.shiftKey && !event.altKey && !event.metaKey) {
        const { isLogined } = store.getters;
        if (isLogined) {
          onShowHotKeyDrawer();
        }
      }
    };
    onMounted(() => {
      ipc.on(ipc.RENDERER_EVENTS_MAP.SHOW_HOT_KEY_DRAWER, onShowHotKeyDrawer);
      document.addEventListener('keydown', onkeydwon);
    });
    onUnmounted(() => {
      ipc.off(ipc.RENDERER_EVENTS_MAP.SHOW_HOT_KEY_DRAWER, onShowHotKeyDrawer);
      document.removeEventListener('keydown', onkeydwon);
    });
    const listData = [
      {
        actionType: i18n_t('文件'),
        actionList: [
          {
            actionName: i18n_t('下载'),
            actionKey: hotkeyDataHelper.getHotKeyTextArrayFromAction('download'),
          },
          {
            actionName: i18n_t('打开'),
            actionKey: hotkeyDataHelper.getHotKeyTextArrayFromAction('open'),
          },
          {
            actionName: i18n_t('分享'),
            actionKey: hotkeyDataHelper.getHotKeyTextArrayFromAction('share'),
          },
          {
            actionName: i18n_t('上传'),
            actionKey: hotkeyDataHelper.getHotKeyTextArrayFromAction('uploadFile'),
          },
          {
            actionName: i18n_t('上传文件夹'),
            actionKey: hotkeyDataHelper.getHotKeyTextArrayFromAction('uploadFolder'),
          },
        ],
      },
      {
        actionType: i18n_t('编辑'),
        actionList: [
          {
            actionName: i18n_t('复制'),
            actionKey: hotkeyDataHelper.getHotKeyTextArrayFromAction('copy'),
          },
          {
            actionName: i18n_t('粘贴'),
            actionKey: hotkeyDataHelper.getHotKeyTextArrayFromAction('paste'),
          },
          {
            actionName: i18n_t('移动'),
            actionKey: hotkeyDataHelper.getHotKeyTextArrayFromAction('move'),
          },
          {
            actionName: i18n_t('删除'),
            actionKey: hotkeyDataHelper.getHotKeyTextArrayFromAction('delete'),
          },
          {
            actionName: i18n_t('重命名'),
            actionKey: hotkeyDataHelper.getHotKeyTextArrayFromAction('rename'),
          },
        ],
      },
      {
        actionType: i18n_t('选择'),
        actionList: [
          {
            actionName: i18n_t('多选'),
            actionKey: ['Shift', i18n_t('点击')],
          },
          {
            actionName: i18n_t('全选'),
            actionKey: hotkeyDataHelper.getHotKeyTextArrayFromAction('selectAll'),
          },
          {
            actionName: i18n_t('点选'),
            actionKey: IS_OPEN_IN_MAC ? ['⌘', i18n_t('点击')] : ['Ctrl', i18n_t('点击')],
          },
        ],
      },
      {
        actionType: i18n_t('功能'),
        actionList: [
          {
            actionName: i18n_t('搜索'),
            actionKey: hotkeyDataHelper.getHotKeyTextArrayFromAction('search'),
          },
          {
            actionName: i18n_t('收藏'),
            actionKey: hotkeyDataHelper.getHotKeyTextArrayFromAction('addFavorite'),
          },
          {
            actionName: i18n_t('快捷键帮助'),
            actionKey: hotkeyDataHelper.getHotKeyTextArrayFromAction('help'),
          },
        ],
      },
    ];
    return {
      hotkeyHelpDrawerShow,
      onClose,
      listData,
    };
  },
});
